import globals from "./globals";
import $ from "cash-dom";
import Swiper, { Navigation, Autoplay } from "swiper";

const layout = (function () {
    /**
     * Initialize Slider instances
     */
    $(document).ready(function () {
        if ($(".slider").length) {
            if (globals.debug) console.log("layout-slider initialized");
            var instances = [];

            $(".slider").each(function (_i, _el) {
                var modules = [];
                var self = _el;
                var controls = self.hasAttribute("data-controls");
                var autoplay = self.hasAttribute("data-autoplay");
                var loop = self.hasAttribute("data-loop");
                var slides = $(self).find(".slide").length;

                console.log(modules);

                instances.push(
                    new Swiper(self, {
                        autoHeight: false,
                        centeredSlides: true,
                        // cssMode: true,
                        // grabCursor: true,
                        spaceBetween: 0,
                        initialSlide: autoplay && loop ? slides - 1 : 0,
                        loop: loop,
                        slidesPerView: "auto",
                        // slidesOffsetBefore: loop ? $(self).find(".slide").width() / -2 : 0,
                        speed: 480,
                        allowTouchMove: false,
                        loopedSlides: 2,
                        modules: [Navigation, Autoplay],
                        navigation: {
                            nextEl: $(self).find(".swiper-button-next")[0],
                            prevEl: $(self).find(".swiper-button-prev")[0],
                            disabledClass: "button-disabled",
                        },
                        on: {
                            slideChange: function () {
                                $(this.el).find(".slide").removeClass("on");
                                $(this.el).find(".slide").eq([this.activeIndex]).addClass("on");
                            },
                        },
                    })
                );

                console.log(instances[_i]);
                if (autoplay) instances[_i].autoplay.start();
            });

            console.log(instances);

            $(window).on("resizeEnd", function () {
                // slider.init();
            });
        }
    });
})();

export default layout;
